export const MinusIcon = () => {
  return (
    <svg width="15" height="2" viewBox="0 0 20 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1H18.3333" stroke="#1e1e1e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const CimMinusIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="1" fill="none" viewBox="0 0 10 1">
      <path stroke="#1E1E1E" strokeLinecap="round" d="M.5.5h8.4"></path>
    </svg>
  );
};
